<script>
    import { spotTypes } from "./Constants";
    import ExpandAllToggle from "./ExpandAllToggle.svelte";

    import IfeCardList from "./IfeComponents/IfeCardList.svelte";
    import IacCardList from "./IacComponents/IacCardList.svelte";
    import {
        selectedField,
        selectedRegion,
        selectedLocality,
        spotType,
        spotTypeBeforeAPICall,
    } from "./Stores";
    import { splitFieldByLocalities } from "./Utils";
    export let spotCards;

    const allFields = getAllFields();

    const allRegions = getAllRegions();

    let allLocalities = [];

    function getAllFields() {
        let allFields = [];
        spotCards.forEach((fieldCard) => {
            allFields.push(fieldCard.field);
        });
        return allFields;
    }

    function getAllRegions() {
        let allRegions = new Set();
        spotCards.forEach((fieldCard) => {
            fieldCard.regions = new Set();
            fieldCard.spots.forEach((spotsPerYear) => {
                Object.keys(spotsPerYear.institutions).forEach((region) => {
                    allRegions.add(region);
                    fieldCard.regions.add(region); // to use for filtering
                });
            });
        });
        return Array.from(allRegions).sort();
    }

    function getAllLocalities() {
        let allLocalities = new Set();
        spotCards
            .find((fieldCard) => fieldCard.field === $selectedField)
            .spots.forEach((spotsPerYear) => {
                if ($selectedRegion) {
                    spotsPerYear.institutions[
                        $selectedRegion
                    ].institutions.forEach((institution) => {
                        allLocalities.add(institution.locality);
                    });
                } else {
                    Object.values(spotsPerYear.institutions).forEach(
                        (region) => {
                            region.institutions.forEach((institution) => {
                                allLocalities.add(institution.locality);
                            });
                        }
                    );
                }
            });
        return Array.from(allLocalities).sort();
    }

    function clearLocalitySelection() {
        $selectedLocality = "";
    }

    $: $selectedRegion,
        (() => {
            if (
                $spotType !== spotTypes.IAC &&
                $spotTypeBeforeAPICall !== spotTypes.IAC &&
                splitFieldByLocalities($selectedField)
            ) {
                allLocalities = getAllLocalities();
            }
        })();
</script>

<h2 class=" mt-5 mb-2 text-2xl" cy_data="spots_title">Vagas Disponíveis</h2>
<p>(u.c. - último colocado)</p>
{#if spotCards}
    <div class=" flex flex-col py-2 items-center max-w-lg">
        {#if $spotType === spotTypes.IFE}
            <select
                class=" md:text-base text-sm rounded-md text-black p-2 focus:outline-none max-w-full"
                cy_data="select_especialidade"
                bind:value={$selectedField}
                on:change={clearLocalitySelection}
            >
                <option value="">Especialidade</option>
                {#each allFields as field}
                    <option value={field}>{field}</option>
                {/each}
            </select>

            <select
                class=" md:text-base text-sm rounded-md text-black p-2 mt-3 focus:outline-none"
                bind:value={$selectedRegion}
                on:change={clearLocalitySelection}
            >
                <option value="">Distrito</option>
                {#each allRegions as region}
                    <option value={region}>{region}</option>
                {/each}
            </select>

            {#if splitFieldByLocalities($selectedField)}
                <select
                    disabled={!$selectedRegion}
                    class=" md:text-base text-sm rounded-md text-black p-2 mt-3 focus:outline-none"
                    bind:value={$selectedLocality}
                >
                    <option value="">
                        Localidade (escolhe primeiro um distrito)
                    </option>
                    {#each allLocalities as locality}
                        <option value={locality}>{locality}</option>
                    {/each}
                </select>
            {/if}

            {#if !$selectedField && !$selectedRegion}
                <ExpandAllToggle />
            {/if}

            <div class=" min-w-full">
                <IfeCardList fieldCards={spotCards} />
            </div>
        {:else if $spotType === spotTypes.IAC}
            <ExpandAllToggle />
            <div class=" min-w-full">
                <IacCardList iacCards={spotCards} />
            </div>
        {/if}
    </div>
{:else}
    <p>Insere os dados para veres a lista de vagas disponiveis</p>
{/if}
